<template>
  <v-dialog v-model="dialog" max-width="1080px" scrollable>
    <v-card class="admin-exclusive-search-modal">
      <v-card-title class="admin-exclusive-search-modal__header">
        <div>
          <h2 class="admin-exclusive-search-modal__title">Adicionar obra exclusiva</h2>
          <p class="admin-exclusive-search-modal__subtitle">Pesquise por nome e selecione uma obra para a curadoria.</p>
        </div>
        <v-spacer />
        <v-btn icon dark aria-label="Fechar busca" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="admin-exclusive-search-modal__content">
        <div class="admin-exclusive-search-modal__search">
          <v-text-field
            v-model="localQuery"
            label="Buscar obra por nome"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            dark
            clearable
            hide-details
            class="custom-input"
            @keyup.enter="search"
            @click:clear="clearSearch"
          />
          <v-btn class="zinnes-primary-btn" dark :loading="loading" @click="search">
            <v-icon left>mdi-magnify</v-icon>
            Buscar
          </v-btn>
        </div>

        <v-alert v-if="error" type="error" dense outlined class="admin-exclusive-search-modal__alert">
          {{ error }}
        </v-alert>

        <div v-if="loading" class="admin-exclusive-search-modal__state">
          <v-progress-circular indeterminate color="var(--zinnes-primary)" />
          <span>Buscando obras...</span>
        </div>

        <div v-else-if="!results.length" class="admin-exclusive-search-modal__state admin-exclusive-search-modal__state--empty">
          <v-icon>mdi-book-search-outline</v-icon>
          <strong>{{ emptyTitle }}</strong>
          <span>{{ emptyText }}</span>
        </div>

        <div v-else class="admin-exclusive-search-modal__grid" aria-live="polite">
          <AdminExclusiveProjectSearchResultCard
            v-for="project in results"
            :key="project.id"
            :project="project"
            :selected="isSelected(project)"
            :disabled="selecting"
            @select="selectProject"
          />
        </div>
      </v-card-text>

      <v-card-actions class="admin-exclusive-search-modal__footer">
        <v-pagination
          v-if="showPagination"
          :value="currentPage"
          :length="lastPage"
          :disabled="loading"
          color="var(--zinnes-primary)"
          total-visible="5"
          @input="$emit('page-change', $event)"
        />
        <v-spacer />
        <v-btn text dark @click="close">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AdminExclusiveProjectSearchResultCard from "./AdminExclusiveProjectSearchResultCard.vue";

export default {
  name: "AdminExclusiveProjectSearchModal",
  components: { AdminExclusiveProjectSearchResultCard },
  props: {
    value: { type: Boolean, default: false },
    query: { type: String, default: "" },
    results: { type: Array, default: () => [] },
    selectedProjectIds: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    selecting: { type: Boolean, default: false },
    error: { type: String, default: "" },
    currentPage: { type: Number, default: 1 },
    lastPage: { type: Number, default: 1 },
  },
  data() {
    return {
      dialog: this.value,
      localQuery: this.query,
      hasSearched: false,
    };
  },
  computed: {
    selectedMap() {
      return this.selectedProjectIds.reduce((map, id) => {
        map[String(id)] = true;
        return map;
      }, {});
    },
    showPagination() {
      return this.lastPage > 1 && !this.loading;
    },
    emptyTitle() {
      return this.hasSearched ? "Nenhuma obra encontrada" : "Comece pesquisando uma obra";
    },
    emptyText() {
      return this.hasSearched
        ? "Tente outro nome ou ajuste a busca para encontrar a obra correta."
        : "Os resultados aparecem aqui como cards selecionaveis.";
    },
  },
  watch: {
    value(newValue) {
      this.dialog = newValue;
    },
    dialog(newValue) {
      this.$emit("input", newValue);
    },
    query(newValue) {
      this.localQuery = newValue;
    },
  },
  methods: {
    search() {
      this.hasSearched = true;
      this.$emit("update:query", this.localQuery || "");
      this.$emit("search", this.localQuery || "");
    },
    clearSearch() {
      this.localQuery = "";
      this.$emit("update:query", "");
      this.$emit("clear");
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    isSelected(project) {
      return !!this.selectedMap[String(project.id)];
    },
    selectProject(project) {
      if (this.isSelected(project)) return;
      this.$emit("select", project);
    },
  },
};
</script>

<style src="../../../styles/home-page/admin.css"></style>
